/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { BuilderPermissionSet, ScheduleType, SystemRoleBit } from '@gh/builder-shared-data';
import { BuilderUserContext } from '@gh/builder-shared';
import { AppRouter } from '@gh/common-shared';

@Component({
    selector: 'gh-schedule-gantt-header-title',
    template: require('./schedule-gantt-header-title.component.html'),
    styles: [require('../schedule-gantt-details-header-component.scss')],
})
export class ScheduleGanttHeaderTitleComponent {
  @Input() details: any;

  constructor(
    private router: AppRouter,
    private userContext: BuilderUserContext,
  ) {
  }

  get isConstruction(): boolean {
    return this.details.type === ScheduleType.Construction;
  }

  get isPreConstruction(): boolean {
    return this.details.type === ScheduleType.PreConstruction;
  }

  get isSales(): boolean {
    return this.details.type === ScheduleType.Sales;
  }

  get isMaintenance(): boolean {
    return this.details.type === ScheduleType.Maintenance;
  }

  get hasRulesForJobView(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Master) ||
      this.userContext.hasSystemRole(SystemRoleBit.Corporate) ||
      (this.userContext.hasPermission(BuilderPermissionSet.JobAdmin.JobDetails.ANY));
  }

  get hasRulesForSalesFolderView(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Master) ||
      this.userContext.hasSystemRole(SystemRoleBit.Corporate) ||
      (this.userContext.hasPermission(BuilderPermissionSet.Sales.Leads.EDIT_VIEW));
  }

  onJobNumberClick(): void {
    if (!this.hasRulesForJobView) {
      return;
    }
    if (this.details.isDpp) {
      this.router.navigateToChild(['/job-admin/jobs/dpp', this.details.jobId], {
        parentTitle: 'lbl_gantt_chart',
      });
    } else {
      this.router.navigateToChild(['/job-admin/jobs', this.details.jobId], {
        parentTitle: 'lbl_gantt_chart',
      });
    }
  }

  onSFNumberClick(): void {
    if (!this.hasRulesForSalesFolderView) {
      return;
    }
    this.router.navigateToChild([`sales/leads`, this.details.customerId], {
      parentTitle: `lbl_gantt_chart`,
      queryParams: {
        salesFolderId: this.details.salesFolderId,
        tab: 'SALES_FOLDERS',
      },
    });
  }
}
